import type { Accessor } from "../types";
import { Data, ThresholdType, TooltipItem } from "./types";

export const compose = (scale: any, accessor: Accessor) => (data: any) =>
  scale(accessor(data));

export const setsToLines = (sets: Data) =>
  sets.reduce(
    (total, { variant, label, ...rest }) =>
      variant === "line"
        ? [
            ...(total as Array<{ label: string; variant: "line" }>),
            { label, variant: "line", ...rest },
          ]
        : total,
    []
  ) as TooltipItem[];

export const setsToBars = (sets: Data) =>
  sets.filter(({ variant }) => variant === "bar");

export const setsToScatterPlots = (sets: Data) =>
  sets.filter(({ variant }) => variant === "scatter-plot");

export const getLegendItems = (sets: Data, thresholds: ThresholdType[]) => {
  const items = [
    ...sets,
    ...thresholds.map((threshold) => ({ ...threshold, variant: "threshold" })),
  ];

  if (items.length) {
    return items;
  }

  return;
};

export const getChartSpacing = (
  height: number,
  parentWidth: number,
  hasBrush: boolean
) => {
  const marginTop = 10;
  const leftAxisWidth = 70;
  const rightAxisWidth = 70;
  const bottomAxisHeight = 20;
  const chartSeparation = hasBrush ? 20 : 0;
  const bottomChartHeight = hasBrush ? 35 : 0;
  const chartHeight =
    height - bottomChartHeight - chartSeparation - bottomAxisHeight;
  const yMax = Math.max(0, chartHeight) - bottomAxisHeight;
  const xMax = Math.max(0, parentWidth) - leftAxisWidth - rightAxisWidth;
  return {
    chartSeparation,
    bottomChartHeight,
    leftAxisWidth,
    rightAxisWidth,
    chartHeight,
    xMax,
    yMax,
    marginTop,
  };
};
